// extracted by mini-css-extract-plugin
module.exports = {"imgBackground":"images_imgBackground__cwt_s","postHeaderImage":"images_postHeaderImage__gNN_H","image":"images_image__XfcGL"};